import { API_URL } from '@idem/common/constantes';
import Empresa from '@frontend/empresa/empresa.view.vue';
import Home from '@frontend/views/home.view.vue';
import AgregarActividadView from '@frontend/empresa/agregar-actividad.view.vue';
import RegistrarEmpresa from '@frontend/empresa/registrar-empresa.view.vue';
import AdministrarEmpresa from '@frontend/empresa/administrar-empresa.vue';

export const empresa = {
  path: '/empresa',
  name: 'Empresa',
  component: Empresa,
  redirect: '/empresa/administrar',
  children: [
    {
      path: 'link',
      name: 'EmpresaLink',
      component: Home,
      beforeEnter() {
        location.href = `${API_URL}/empresa/link`;
      },
    },
    {
      path: 'actividad',
      name: 'AgregarActividadEmpresa',
      component: AgregarActividadView,
    },
    {
      path: 'registrar',
      name: 'RegistrarEmpresa',
      component: RegistrarEmpresa,
    },
    {
      path: 'administrar',
      name: 'AdministrarEmpresa',
      component: AdministrarEmpresa,
    },
  ],
};
